import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import {
  AuthorInfoParams,
  AuthorResponseItem,
  SimpleAuthorInfo,
} from '@/shared/types';

const convertAuthor = (author: AuthorResponseItem): SimpleAuthorInfo => {
  return {
    id: author.id,
    name: author.name,
    tagLine: author.tagline,
    subscriptionCount: author.subscription_count,
    isCompany: author.is_company,
    isSubscribed: author.is_subscribed,
    urlIdentifier: author.author_url_identifier,
    imageUrl: author.image_url,
  };
};

const useAuthorProfileInfo = ({ authorId }: AuthorInfoParams) => {
  return useQuery({
    queryKey: ['authorInfoApi', authorId],
    queryFn: async () => {
      const { data } = await clientAxios.get('/authorInfoApi/', {
        params: { authorId },
      });

      const organizedAuthorInfo = convertAuthor(data.data);

      return organizedAuthorInfo;
    },
  });
};

export default useAuthorProfileInfo;
